import { render, staticRenderFns } from "./Merci.vue?vue&type=template&id=622a81ed&scoped=true&"
import script from "./Merci.vue?vue&type=script&lang=js&"
export * from "./Merci.vue?vue&type=script&lang=js&"
import style0 from "./Merci.vue?vue&type=style&index=0&id=622a81ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622a81ed",
  null
  
)

export default component.exports